export default __webpack_public_path__ + "static/media/product_placeholder.d99718f6.png";